// filter out props not used by AnimatedHeightWithRef
// this allows us to create an intersection set inside of withAnimatedHeight
// of which we then spread those props over the Component passed in
// it also allows us to spread all props we are not using inside of
// AnimatedToggle on top of AnimatedHeight without the risk of spreading
// an unsupported prop atop of AnimatedHeight.
export const extractAnimatedHeightProps = ({children, element, innerProps, outerProps, render, otherProps, show, initialHeight}) =>
  ({children, element, innerProps, outerProps, render, otherProps, show, initialHeight})

export const filterObjectByExcludedKeys = (objectToFilter, excludedKeys) => {
  return Object.entries(objectToFilter)
    .filter(([key]) => !excludedKeys.includes(key))
    .reduce((accumulator, [key, value]) => {
      accumulator[key] = value;

      return accumulator;
    }, {});
};